const ded = `
<h1>Política de Uso de la Inteligencia Artificial (IA) en la Plataforma DressDown</h1>

<h2>Cumplimiento de la legislación de la UE</h2>
<ul>
  <li>Reglamento General de Protección de Datos (RGPD): en el tratamiento de datos personales.</li>
  <li>Ley de Inteligencia Artificial (AI Act): en el uso e implementación de sistemas de IA.</li>
  <li>Carta de los Derechos Fundamentales de la Unión Europea: especialmente los artículos 7 (respeto a la vida privada y familiar) y 8 (protección de los datos personales).</li>
</ul>

<h2>Transparencia y etiquetado del contenido generado por IA</h2>
<p>Todas las imágenes generadas mediante tecnologías de inteligencia artificial deben ir acompañadas obligatoriamente de la siguiente advertencia:<br>
<strong>Generado por IA. No es una fotografía real. Cualquier semejanza es pura coincidencia.</strong></p>
<p>Esta práctica garantiza la transparencia y la información al usuario, en conformidad con los principios de equidad y honestidad establecidos por la legislación de la UE, en particular el Reglamento (UE) 2019/1150 sobre la promoción de la equidad y la transparencia para los usuarios empresariales de plataformas en línea, así como el Código de Buenas Prácticas contra la Desinformación recomendado por la Comisión Europea.</p>
<p>Se presta especial atención al etiquetado de contenidos que puedan ser percibidos como periodísticos, científicos o políticamente relevantes, para evitar la difusión de desinformación y proteger el derecho de los usuarios a recibir información veraz, conforme al artículo 11 (libertad de expresión) de la Carta de los Derechos Fundamentales de la UE.</p>

<h2>Consentimiento y protección de la privacidad</h2>
<ul>
  <li>Está prohibido el uso de imágenes reales de personas sin su consentimiento explícito, incluyendo:
    <ul>
      <li>Fotos de cuentas personales.</li>
      <li>Datos biométricos.</li>
      <li>Imágenes médicas e íntimas.</li>
    </ul>
  </li>
  <li>No almacenamos ni utilizamos datos personales sensibles en los sistemas generativos.</li>
</ul>

<h2>Restricciones sobre contenido dañino</h2>
<p>Está prohibido utilizar los sistemas de IA de DressDown para generar o difundir:</p>
<ul>
  <li>Contenido que contenga elementos de discriminación, racismo, sexismo u otras formas de odio.</li>
  <li>Imágenes con contenido violento, pornográfico o difamatorio.</li>
  <li>Desinformación o deepfakes que engañen o perjudiquen la reputación.</li>
</ul>

<h2>Restricciones éticas y moderación</h2>
<ul>
  <li>Las solicitudes que infrinjan normas sociales o puedan causar daño social se bloquean automáticamente.</li>
  <li>Se realiza moderación: las actividades sospechosas pueden ser revisadas manualmente.</li>
  <li>El contenido que infrinja esta política se elimina y los infractores son bloqueados.</li>
</ul>

<h2>Protección de Derechos de Autor</h2>
<ul>
  <li>La generación de imágenes no debe copiar estilos reconocibles de artistas o fotógrafos sin su autorización.</li>
  <li>Está prohibido crear obras que puedan infringir los derechos de propiedad intelectual de terceros.</li>
</ul>

<h2>Medidas Técnicas de Protección</h2>
<p>La plataforma DressDown.me implementa un conjunto de medidas técnicas y organizativas para garantizar la seguridad del tratamiento de datos relacionado con el uso de tecnologías de inteligencia artificial (IA). Estas medidas están destinadas a proteger los datos personales de los usuarios frente al acceso no autorizado, pérdida, alteración o divulgación, y a garantizar el cumplimiento de la legislación vigente.</p>
<ul>
  <li>Cifrado de datos durante la transmisión y el almacenamiento utilizando protocolos de seguridad modernos como TLS/SSL, de acuerdo con las recomendaciones de la Agencia de la Unión Europea para la Ciberseguridad (ENISA).</li>
  <li>Restricción del acceso a los sistemas de IA y a los datos personales únicamente a empleados y socios autorizados que estén obligados a respetar las condiciones de confidencialidad, conforme al Artículo 32 del RGPD (Seguridad del Tratamiento).</li>
  <li>Actualización regular del software y del hardware para eliminar vulnerabilidades y prevenir ciberataques.</li>
  <li>Monitoreo, auditoría y pruebas continuas de los sistemas de seguridad para detectar y responder oportunamente a incidentes, en cumplimiento de la norma ISO/IEC 27001 de gestión de seguridad de la información.</li>
  <li>Cumplimiento del Reglamento General de Protección de Datos (RGPD) (Reglamento (UE) 2016/679), así como de otras normativas aplicables de la Unión Europea.</li>
</ul>
<p>El tratamiento de datos con IA se realiza de acuerdo con los principios de minimización de datos (Art. 5 del RGPD) y limitación de la finalidad, y los datos no se conservan más tiempo del necesario para cumplir con los fines del tratamiento.</p>

<h2>Sus Derechos</h2>
<p>De acuerdo con el RGPD, los usuarios tienen derecho a:</p>
<ul>
  <li>Acceder a sus datos.</li>
  <li>Retirar el consentimiento para su tratamiento.</li>
  <li>Solicitar la eliminación o corrección de datos relacionados con la generación de imágenes.</li>
</ul>
<p>Si considera que su contenido, imagen o datos han sido utilizados sin su consentimiento, puede contactarnos a <a href="mailto:dressdown@dressdown.me">dressdown@dressdown.me</a>. Garantizamos una revisión y respuesta en un plazo de 30 días naturales.</p>
`;

export default ded
